// extracted by mini-css-extract-plugin
module.exports = {"login_form":"login_login_form__2yej9"};